
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Part } from '../../types'

@Component({
    name: 'image-shape',
})
export default class ImageShape extends Vue {
    @Prop({ type: Object }) part!: Part
}
